module.exports = __webpack_public_path__ + "img/Linea_tiempo.1911d967.svg";